import { Button } from "@/components/shadcn/button";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type SubmitButtonProps = {
  text: string;
  icon?: IconDefinition,
  tooltip?: string,
  className?: string;
};

export const SubmitButton = ({ text, icon, tooltip, className }:SubmitButtonProps) => {
  return (
    <Button 
      type="submit" 
      variant={"success"}
      size={"sm"}
      title={tooltip}
      className={className}
      >
      {text} {icon && <FontAwesomeIcon icon={icon} data-testid="icon" /> }
    </Button>
  );
};
